export default __webpack_public_path__ + "static/media/consulta.18ff09e0.svg";